<template>
  <loan-list
    filter="Payday"
    :title="$t('menu.payDayLoan')"
  />
</template>

<script>
import LoanList from './List'

export default {
  name: 'PayDayLoanList',
  metaInfo () {
    return {
      title: this.$t('menu.payDayLoan'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  },
  components: { LoanList }
}
</script>

<style scoped>

</style>
